import React from 'react';

import styled, { css } from 'styled-components';

import {
  FilterDrawerCustomFilters as BaseFilterDrawer,
  ProductBrowserCustomFilters,
} from '@techstyle/react-components';

import { mobile } from '../../styles';
import FilterDrawerV2 from '../FilterDrawerV2/FilterDrawer';
import { SortedByDrawer } from '../FilterDrawerV2/SortedBySection';
import FilterTags from '../FilterTags';
import ProductFilters from '../ProductFilters';

const nestedHeadingStyle = css`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: ${0.83 / 10}em;
  color: ${({ theme }) => theme.colors.subdued};
  padding-bottom: ${({ theme }) => theme.spacing.tiny}px;

  @media (min-width: ${({ theme }) =>
      theme.breakpoints.small}px) and (max-width: ${({ theme }) =>
      theme.breakpoints.xlarge}px) {
    padding-top: 0;
  }
`;

const nestedListStyle = css`
  padding-top: 0;

  text-transform: uppercase;
`;

const StyledProductFilters = styled(ProductFilters)`
  > button[aria-expanded] {
    padding: ${props => props.theme.spacing.small}px;
  }

  ${mobile`
    > button {
      height: 72px;
    }
  `}
`;

export const MobileFilterTags = styled(ProductBrowserCustomFilters.FilterTags)`
  ${mobile`
    padding-bottom: 18px;
  `}
`;

const BaseFilterDrawerContent = styled(BaseFilterDrawer.Content)`
  padding-top: ${props => props.theme.spacing.moderate}px;
`;

function FilterDrawer({ handleAppliedFilters }) {
  return (
    <FilterDrawerV2 handleAppliedFilters={handleAppliedFilters}>
      <SortedByDrawer />
      <BaseFilterDrawerContent>
        <FilterTags as={MobileFilterTags} />
        <BaseFilterDrawer.Filters>
          <StyledProductFilters
            nestedHeadingStyle={nestedHeadingStyle}
            nestedListStyle={nestedListStyle}
          />
        </BaseFilterDrawer.Filters>
      </BaseFilterDrawerContent>
    </FilterDrawerV2>
  );
}

export default FilterDrawer;
